<template lang="pug">
#page_content.page.news
	Banner(v-bind:item='item_banner', classes='half no_title external_link')
	.container.article
		h2.title {{ item.title }}
		hr
		h5.datetime {{ item.datetime }}
		.content(v-html='item.content')
		hr
		.list_share
			.item_share
				ShareNetwork(
					network='facebook',
					v-bind:url='seo_info.url',
					v-bind:title='seo_info.title',
					v-bind:description='seo_info.desc'
				)
					img(src='@/assets/images/icon_fb.svg')
			.item_share
				ShareNetwork(
					network='line',
					v-bind:url='seo_info.url',
					v-bind:title='seo_info.title',
					v-bind:description='seo_info.desc',
					v-bind:popup='{ width: 500, height: 500 }'
				)
					img(src='@/assets/images/icon_line.svg')
			#copy.item_share(
				data-bs-toggle='tooltip',
				data-bs-placement='top',
				v-bind:title='$t("news_item_copy")',
				v-bind:data-bs-original-title='$t("news_item_copy")',
				v-on:click='handleTooltip'
			)
				img(src='@/assets/images/icon_link.svg')
</template>

<script>
import { indexNews } from '@/router/api.js';
import { Tooltip } from 'bootstrap';
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			id: '',
			item: {},
			tooltip: null,
			item_banner: {
				media: 'https://swiperjs.com/demos/images/nature-1.jpg',
			},
			seo_info: {
				title: '',
				description: '',
				url: '',
			},
		};
	},
	methods: {
		getNews: function () {
			indexNews().then(res => {
				let temp = res.data.filter(item => item.id == this.id)[0];
				if (temp) {
					this.item = temp;
					this.item_banner.media =
						process.env.VUE_APP_WP_IMAGE_PREFIX + temp.image;
					this.seo_info.title = this.item.title;
					this.seo_info.description = this.item.desc;
					this.seo_info.url = window.location.href;
				} else {
					this.$router.push({ name: 'Index' });
				}
			});
		},
		copyText: function (text) {
			let textArea = document.createElement('textarea');
			textArea.value = text;
			textArea.style.position = 'fixed'; //avoid scrolling to bottom
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			document.execCommand('copy');
			document.body.removeChild(textArea);
			return;
		},
		handleTooltip: function () {
			this.copyText(this.seo_info.url);

			let target = document.getElementById('copy');
			target.setAttribute(
				'data-bs-original-title',
				this.$t('news_item_copied')
			);

			this.tooltip.show();

			setTimeout(() => {
				target.setAttribute(
					'data-bs-original-title',
					this.$t('news_item_copy')
				);
				this.tooltip.hide();
			}, 1000);
		},
	},
	created() {
		this.id = this.$route.params.id;
		this.getNews();
	},
	mounted() {
		this.tooltip = new Tooltip(document.getElementById('copy'));
	},
	components: {
		Banner,
	},
};
</script>

<style lang="stylus">
#page_content
	&.news
		#banner
			@media screen and (max-width: $screen-sm-max)
				padding-top: 170px
				.image
					mask: unset
		.article
			padding: 5rem 10vw 3rem
			.title
				text-align: center
				margin-bottom: 20px
				line-height: 1.5
			hr
				margin-bottom: 0.5rem
			.datetime
				margin-bottom: 20px
				color: $color_light
				text-align: right
				font-weight: 500
			.list_share
				display: flex
				justify-content: center
				margin-top: 40px
				.item_share
					margin-right: 24px
					&:last-child
						margin-right: 0
						cursor: pointer
			@media screen and (max-width: $screen-sm-max)
				padding: 2rem 20px
		.content
			p
				line-height: 2rem
				margin-bottom: 2.5rem
			figure
				margin-bottom: 2.5rem
				img
					height: unset
			ul
				&.blocks-gallery-grid
					list-style: none
					padding: 0
					text-align: center
			.alignleft
				text-align: left
			.aligncenter
				text-align: center
			.alignright
				text-align: right
</style>
